/*
 * The one cutover between mobile and desktop sponsor inventory, shared by every
 * page that renders a slot.
 *
 * Event show used to switch at `sm` (640px) while track show switched at `md`
 * (768px), so a 700px viewport — small tablet, landscape phone — was served the
 * 728×90 on an event page and the 320×100 on a track page. Past looking
 * inconsistent, it meant the impression counts for those two slots were not
 * measuring comparable audiences.
 *
 * `md` is the cutover because a 728×90 needs roughly its own width of content
 * space to render at native size. At 640px the event page has about 608px after
 * `px-4`, which squeezed the leaderboard to ~83% — a visibly distorted ad in the
 * exact band `sm` opened up. It also lines up with the 767px breakpoint the app
 * already uses in application.css.
 *
 * These are literal class strings rather than an interpolated breakpoint token
 * because Tailwind only registers classes it can find as literals in source.
 * Both must keep the same breakpoint — that is the whole point of this file.
 */
export const SPONSOR_DESKTOP_ONLY = "hidden md:block";
export const SPONSOR_MOBILE_ONLY = "md:hidden";
